/* eslint-disable no-unused-vars */
import { IfVisible, STATUS_ACTIVE } from './ifvisible'

export default class Timer {
    private token: number | undefined;

    stopped = false;

    constructor (private ifvisible: IfVisible,
        private seconds: number,
        // eslint-disable-next-line @typescript-eslint/ban-types
        private callback: Function) {
        this.start()

        this.ifvisible.on('statusChanged', (data: any) => {
            if (this.stopped === false) {
                if (data.status === STATUS_ACTIVE) {
                    this.start()
                } else {
                    this.pause()
                }
            }
        })
    }

    private start () {
        this.stopped = false
        clearInterval(this.token)
        this.token = setInterval(this.callback, this.seconds * 1000)
    }

    stop (): void {
        this.stopped = true
        clearInterval(this.token)
    }

    resume (): void {
        this.start()
    }

    pause (): void {
        this.stop()
    }
}
